import { Injectable } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { IFormField } from '../models/form-field';

@Injectable({
  providedIn : 'root'
})
export class CustomFormFieldService {

  constructor(private _formBuilder : FormBuilder) { }

  createFormGroup(formFields : Array<IFormField>) : FormGroup {
    const customForm : FormGroup = this._formBuilder.group({});
    formFields.forEach((form : IFormField) => {
      if(form.updateOn) {
        const validators = form.validators as any;
        customForm.addControl(form.fieldName, new FormControl(form.defaultValue, {validators : validators, updateOn: form.updateOn}));
      } else {
        customForm.addControl(form.fieldName, new FormControl(form.defaultValue, form.validators));
      }
    });
    return customForm;
    // TBD : Add support for nested form groups
  }

}
